import { gql } from "@apollo/client";
export const DropdownType = gql`
  fragment DropdownType on DropdownType {
    label
    value
    leave_left
  }
`;
